import { LoadingIndicator } from 'components/loading'
import { useImovelInformacoesCadastraisQuery } from 'graphql/hooks.generated'
import { useParams } from 'react-router'

import { InformacoesCadastraisPageContent } from './InformacoesCadastraisPageContent'
import { ImovelUrlParams } from './model-visualizacao-imovel'
import { createImovelNotFoundError } from './utils-visualizacao-imovel'

export function VisualizarInformacoesCadastraisView() {
  const { imovelId } = useParams<ImovelUrlParams>()

  const { data, loading, error } = useImovelInformacoesCadastraisQuery({
    variables: { input: imovelId },
    fetchPolicy: 'network-only',
  })

  const imovel = data?.imovel

  if (loading) {
    return <LoadingIndicator />
  }

  if (error) {
    throw error
  }

  if (!imovel) {
    throw createImovelNotFoundError('VisualizarInformacoesCadastraisView', imovelId)
  }

  return <InformacoesCadastraisPageContent imovel={imovel} />
}
